import * as React from 'react';

import PropTypes from 'prop-types';

import EmailPreferencesList from 'bundles/account-settings/components/sections/email-preferences/cds/EmailPreferencesList';
import { Sections } from 'bundles/account-settings/constants/SettingsConstants';
import type {
  CourseraNormalizedEmailPreference,
  GlobalNotificationPreferences,
  UpdateStatus,
} from 'bundles/account-settings/types/EmailPreferences';

import _t from 'i18n!nls/account-settings';

type Props = {
  preferences: GlobalNotificationPreferences;
  updateStatus: UpdateStatus;
  disabled: boolean;
};

type State = {
  preferences: CourseraNormalizedEmailPreference[];
};

class CourseraEmailPreferences extends React.Component<Props, State> {
  static propTypes = {
    preferences: PropTypes.object.isRequired,
    updateStatus: PropTypes.object.isRequired,
  };

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);

    this.state = {
      preferences: CourseraEmailPreferences.preparePreferences(props.preferences),
    };
  }

  static preparePreferences = function (preferences: GlobalNotificationPreferences) {
    return [
      {
        id: 'recommendations',
        name: _t('Weekly personalized course recommendations'),
        value: {
          recommendations: preferences.recommendations,
        },
      },
      {
        id: 'promotions',
        name: _t('Weekly notifications about promotions, new courses and programs, and special events'),
        value: {
          promotions: preferences.promotions,
        },
      },
      {
        id: 'degrees',
        name: _t('Information on online Master’s and Bachelor’s Degree programs'),
        value: {
          degrees: preferences.degrees,
        },
      },
      {
        id: 'volunteer',
        name: _t(`Surveys and invitations to help us improve Coursera content and your experience`),
        value: {
          volunteer: preferences.volunteer,
        },
      },
    ];
  };

  render() {
    return (
      <EmailPreferencesList
        disabled={this.props.disabled}
        type={Sections.COURSERA_EMAIL_PREFERENCES}
        emailPreferences={this.state.preferences}
        updateStatus={this.props.updateStatus}
      />
    );
  }
}

export default CourseraEmailPreferences;
